import * as React from 'react'
import PropTypes from 'prop-types'
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress'

import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Colors from 'utils/Colors'

const CircularProgressWithLabel = (props) => {
  const { backgroundColor, foregroundColor, ...rest } = props
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: backgroundColor || Colors.googleYellow,
        }}
        {...rest}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        sx={{
          color: foregroundColor || Colors.green,
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        {...rest}
      />  
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0,
        }}
      >
        <Typography
          variant="h3"
          component="h3"
          color="text.primary"
          fontSize={props.size / 8}
        >
          {props.legend}
        </Typography>
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          fontSize={props.size / 7}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
}

export default CircularProgressWithLabel
